import AnalyticsStore from '@migrate/stores/AnalyticsStore'
import UserNotificationStore from '@migrate/stores/UserNotificationStore'
import { EntityTypeStore } from '@migrate/stores/EntityTypeStore'
import { LocalesStore } from '@migrate/stores/LocalesStore'
import { HyperMediaStore } from '@migrate/stores/HyperMediaStore'
import SharedStore from '@migrate/stores/SharedStore'
import EnablementStore from '@migrate/stores/EnablementStore'
import { CategoryStore } from '@migrate/stores/CategoryStore'
import UsersStore from '@migrate/stores/UsersStore'
import { EntityTypeApi } from '@portal/pkg-api/navigator'
import { PortalConfigStore } from '@shared/adapter/PortalConfigStore'
import SecurityStore from '@migrate/stores/SecurityStore'
import EntityDetailTabStore from '@migrate/components/navigator/stores/EntityDetailTabStore'
import GridViewStore from '@migrate/components/navigator/stores/GridViewStore'

export const stores: any = {}

export function createStores() {
  stores[UserNotificationStore.STORE_NAME] = new UserNotificationStore()

  stores[LocalesStore.STORE_NAME] = new LocalesStore()
  stores[AnalyticsStore.STORE_NAME] = new AnalyticsStore()
  stores[EntityTypeStore.STORE_NAME] = new EntityTypeStore(EntityTypeApi)
  stores[HyperMediaStore.STORE_NAME] = new HyperMediaStore()
  stores[EnablementStore.STORE_NAME] = new EnablementStore()
  stores[CategoryStore.STORE_NAME] = new CategoryStore()
  stores[UsersStore.STORE_NAME] = new UsersStore()
  stores[PortalConfigStore.STORE_NAME] = PortalConfigStore

  // shared store should come last so the other stores are created
  stores[SharedStore.STORE_NAME] = new SharedStore(
    stores[EntityTypeStore.STORE_NAME],
    stores[HyperMediaStore.STORE_NAME],
    stores[CategoryStore.STORE_NAME],
    stores[EnablementStore.STORE_NAME],
    stores[AnalyticsStore.STORE_NAME],
    stores[UsersStore.STORE_NAME],
    stores[LocalesStore.STORE_NAME],
    stores[PortalConfigStore.STORE_NAME],
    SecurityStore,
    stores[UserNotificationStore.STORE_NAME],
  )

  return stores
}

export function getCategoryStore(): CategoryStore {
  return stores[CategoryStore.STORE_NAME]
}

export function getLocaleStore(): LocalesStore {
  return stores[LocalesStore.STORE_NAME]
}

export function getUserNotificationStore(): UserNotificationStore {
  return stores[UserNotificationStore.STORE_NAME]
}

export function getUsersStore(): UsersStore {
  return stores[UsersStore.STORE_NAME]
}

export function getEnablementStore(): EnablementStore {
  return stores[EnablementStore.STORE_NAME]
}

export function getEntityTypeStore(): EntityTypeStore {
  return stores[EntityTypeStore.STORE_NAME]
}

export function getHyperMediaStore(): HyperMediaStore {
  return stores[HyperMediaStore.STORE_NAME]
}

export function getSharedStore(): SharedStore {
  return stores[SharedStore.STORE_NAME]
}

// This is a hack to allow class-based and hook-based code to access this store.
let entityDetailTabStore: EntityDetailTabStore
export function getEntityDetailTabStore(): EntityDetailTabStore {
  if (!entityDetailTabStore) {
    entityDetailTabStore = new EntityDetailTabStore(getHyperMediaStore())
  }
  return entityDetailTabStore
}

let gridViewStore: GridViewStore | undefined

export function setGridViewStore(store: GridViewStore) {
  gridViewStore = store
}

export function getGridViewStore(): GridViewStore | undefined {
  return gridViewStore
}
